/**
 * COMMERCE-R5.2 — mint short-lived HTTPS PDF access URL (no blob:).
 */
import { storeV2AuthHeaders } from "./store-v2-auth-headers-v2.js";

export function parseCustomerDocumentUrl(url: string): {
  orderId: string;
  documentId: string;
  sessionKey: string;
} | null {
  try {
    const u = new URL(url, window.location.origin);
    const orderId = String(u.searchParams.get("order_id") ?? "").trim();
    const documentId = String(u.searchParams.get("document_id") ?? "").trim();
    const sessionKey = String(u.searchParams.get("session_key") ?? "").trim();
    if (!orderId || !documentId || !sessionKey) return null;
    return { orderId, documentId, sessionKey };
  } catch {
    return null;
  }
}

export async function mintCustomerDocumentHttpsUrl(opts: {
  url: string;
  mode: "inline" | "download";
}): Promise<{ ok: true; httpsUrl: string; documentId: string } | { ok: false; messageUk: string; messageEn: string }> {
  const parsed = parseCustomerDocumentUrl(opts.url);
  if (!parsed) {
    return {
      ok: false,
      messageUk: "Не вдалося відкрити документ.",
      messageEn: "Could not open document.",
    };
  }
  const mintUrl = `/api/store-v2/order-document-access?order_id=${encodeURIComponent(parsed.orderId)}&document_id=${encodeURIComponent(parsed.documentId)}&session_key=${encodeURIComponent(parsed.sessionKey)}`;
  const res = await fetch(mintUrl, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      ...storeV2AuthHeaders(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      session_key: parsed.sessionKey,
      operation: opts.mode === "download" ? "download" : "view",
    }),
  });
  if (!res.ok) {
    return {
      ok: false,
      messageUk: "Не вдалося відкрити документ.",
      messageEn: "Could not open document.",
    };
  }
  const data = (await res.json()) as { ok?: boolean; url?: string };
  const httpsUrl = String(data.url ?? "").trim();
  if (!data.ok || !httpsUrl.startsWith("https://") || httpsUrl.startsWith("blob:")) {
    return {
      ok: false,
      messageUk: "Перегляд документа налаштовано некоректно.",
      messageEn: "Document viewer misconfigured.",
    };
  }
  return { ok: true, httpsUrl, documentId: parsed.documentId };
}
